










import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import UiTag from '@/components/Ui/Tag/Tag.vue'
import UiProgress from '@/components/Ui/Progress/Progress.vue'
import statusComponent from '@/components/polls/status.vue'
import Poll from '@/models/polls/Poll'
import {MAILING_STATUS_PROGRESS} from '@/constants';

export default Vue.extend({
  name: 'pollPageStatusBlock',
  props: {
    scope: {} as () => {poll: Poll},
    options: {}
  },
  components: {
    infoRowsBlock,
    UiTag,
    UiProgress,
    statusComponent
  },
  data () {
    return {
      MAILING_STATUS_PROGRESS
    }
  },
  computed: {
    sendProgress (): number {
      return this.scope.poll.getSendProgress();
    },
    isProgress (): boolean {
      return this.scope.poll.getStatus() === MAILING_STATUS_PROGRESS
    }
  }
})
